import { render, staticRenderFns } from "./submitBilling.vue?vue&type=template&id=6d74715a&scoped=true&"
import script from "./submitBilling.vue?vue&type=script&lang=js&"
export * from "./submitBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d74715a",
  null
  
)

export default component.exports